import { environment } from 'environments/environment';
import { AuthenticationService, SpinnerService } from '@sgprev-services';
import { AfterViewInit, Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PrimeNGConfig } from 'primeng/api';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
    title = 'sgprev-ui';
    public hasInited = false;

    constructor(
        private authService: AuthenticationService,
        public spinnerService: SpinnerService,
        private config: PrimeNGConfig, private zone: NgZone) { }

    public get isLoadingSpinnerVisible(): BehaviorSubject<boolean> {
        return this.spinnerService.isLoaging;
    }

    ngOnInit(): void {
        window.addEventListener('message', this.receiveSession);
        this.loadTokenFromParameters();

        this.config.setTranslation({
            dayNames: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
            dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
            dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
            monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
            monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
            today: 'Hoje',
            clear: 'Limpar',
            dateFormat: 'dd/mm/yy',
            weekHeader: 'Semana'
        });
    }

    private readonly receiveSession = (event: MessageEvent): void => {
        if (event.source !== window.parent || event.origin !== new URL(environment.LEGACY_URL).origin) return;
        this.zone.run(() => {
            if (event.data?.sessionExpired) { this.authService.clearToken(); this.hasInited = false; return; }
            this.applySession(event.data?.token, event.data?.guardiao, event.data?.identity);
        });
    };

    /** Como antes de 21/09: o guardião identifica o operador (a API o recebe em X-SGPREV-Guardiao).
     *  O token é gravado quando o legado consegue emiti-lo, mas não é obrigatório: se o login do
     *  legado na API falhar, o iframe chega com "token=" vazio e o módulo precisa abrir mesmo assim.
     *  A identidade assinada é opcional e só existe quando o legado publicado a emitir. */
    private applySession(token: unknown, guardiao: unknown, identity: unknown): void {
        try {
            const user = typeof guardiao === 'string' ? parseGuardiao(guardiao) : guardiao;
            if (!user || typeof user !== 'object' || Array.isArray(user)) throw new Error('Sessão inválida');
            // Descarta o que houver de um acesso anterior antes de gravar o atual.
            this.authService.clearToken();
            if (typeof token === 'string' && token) this.authService.token = token;
            this.authService.guardiao = user;
            this.authService.identity = typeof identity === 'string' && identity ? identity : null;
            this.hasInited = true;
        } catch {
            this.authService.clearToken();
            this.hasInited = false;
        }
    }

    private loadTokenFromParameters(): void {
        const url = new URL(window.location.href);
        if (url.searchParams.has('token') || url.searchParams.has('guardiao') || url.searchParams.has('identity')) {
            this.applySession(url.searchParams.get('token'), url.searchParams.get('guardiao'), url.searchParams.get('identity'));
            ['token', 'guardiao', 'identity'].forEach(key => url.searchParams.delete(key));
            window.history.replaceState(window.history.state, '', url.toString());
        } else {
            this.applySession(this.authService.token, this.authService.guardiao, this.authService.identity);
        }
    }

    ngAfterViewInit(): void { }
    ngOnDestroy(): void { window.removeEventListener('message', this.receiveSession); }
}

/** JSON do Guardião vindo do legado (Gson). Aceita também a forma codificada em URL, como o front antigo lia. */
function parseGuardiao(valor: string): unknown {
    try {
        return JSON.parse(valor);
    } catch {
        return JSON.parse(decodeURIComponent(valor));
    }
}
